import React, { useEffect, useState } from "react";
import MiniPackagesCard from "./shared/MiniPackagesCard";
import SeeAllMiniPackagesSkeleton from "./shared/SeeAllMiniPackagesSkeleton";
import { AiOutlineArrowLeft } from "react-icons/ai";
import { useNavigate } from "react-router-dom";
import SubscriptionService from "services/subscription/subscriptionService";
import {
  MiniPackagesResponse,
  subscriptionsResponse,
} from "services/subscription/types";

const SeeAllMiniPackages = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [allSubscriptionsPackages, setAllSubscriptionPackages] =
    useState<subscriptionsResponse>();

  //get all mini packages
  const fetchAllMiniPackages = async () => {
    try {
      setIsLoading(true);
      const resp = await SubscriptionService.getPackages();
      if (resp.status) {
        setAllSubscriptionPackages(resp.data);
      }
    } catch (err) {
      console.log("err ::::", err);
    } finally {
      setIsLoading(false);
    }
  };

  //fetch mini packages data
  useEffect(() => {
    fetchAllMiniPackages();
  }, []);

  return (
    <>
      {!isLoading && (
        <div>
          {/* main topic section */}
          <div>
            <button
              className="w-10 h-10 mb-5 bg-white rounded-full max-sm:ml-[16px]"
              onClick={() => navigate(-1)}
            >
              <AiOutlineArrowLeft className="ml-3" />
            </button>
          </div>
          <div className="mb-8">
            <h1 className="text-[20px] font-medium text-white lg:text-2xl md:text-2xl max-sm:w-[60%] max-sm:ml-2">
              All Mini Packages
            </h1>
          </div>
          {allSubscriptionsPackages?.mini && (
            <div className="grid w-full grid-cols-2 gap-4 mt-4 mb-8 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 2xl:grid-cols-6 max-sm:w-full">
              {allSubscriptionsPackages?.mini?.map(
                (card: MiniPackagesResponse, i: number) => (
                  <div key={i} className="mb-2">
                    <MiniPackagesCard card={card} />
                  </div>
                ),
              )}
            </div>
          )}
        </div>
      )}

      {isLoading && <SeeAllMiniPackagesSkeleton />}
    </>
  );
};

export default SeeAllMiniPackages;
